const workFlowFeilds = [
  {
    label: "Workflow Name",
    name: "name",
    type: "input",
    rules: [{ required: true, message: "Please input your workflow name!" }],
  },
  {
    label: "Workflow Type",
    name: "workflow_type_id",
    type: "select",
    options: [],
    values: [],
    rules: [{ required: true, message: "Please select Workflow Type!" }],
  },
  {
    label: "Collaborated By",
    name: "collaborated_by",
    type: "select",
    options: [],
    values: [],
    rules: [{ required: true, message: "Please select Collaborated By!" }],
  },
  {
    label: "Workflow Owner",
    name: "owner_id",
    type: "select",
    options: [],
    values: [],
    rules: [{ required: true, message: "Please select Workflow Type!" }],
  },
  {
    label: "Workflow Due",
    name: "due_date",
    type: "datepicker",
    rules: [{ required: true, message: "Please select Workflow due!" }],
  },
  {
    label: "Frequency",
    name: "frequency",
    type: "select",
    options: ["On Demand", "Recurrent"],
    values: ["ondemand", "recurrent"],
    rules: [{ required: true, message: "Please select a frequency!" }],
  },
  {
    label: "Interval (months)",
    name: "interval",
    type: "number",
    hidden: true,
    // rules: [{ required: true, message: "Please input interval in months!" }],
  },
];

export default workFlowFeilds;
